<div class="modal-header">
  <button
    type="button"
    class="btn-close close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div
  class="modal-body new-message-dialog-modal-body item-{{
    postData?.content?.entityId
  }}"
>
  <ng-container *ngIf="isLoadingAttributeDescriptions$ | async">
    <div class="d-flex justify-content-center align-items-center">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
  </ng-container>

  <div *ngIf="postData?.message">
    <app-post-details-content
      [senderProfileImg]="postData?.from?.image"
      [senderId]="postData?.from?.id"
      [senderName]="getSender()"
      [dateTime]="
        postData?.dateTime | localizedDate : DateFormat.FullDateTimeCommon4
      "
      [showDate]="!hideMessageDate"
      [copied]="copied"
      [copyPostLink]="copyPostLink.bind(this)"
      [rawHtml]="rawHtml"
      [streams]="streams"
      [category]="postData?.content?.category"
      [canViewDetails]="true"
      [showBackBtn]="false"
      [peopleURL]="peopleURL"
      [postData]="postData"
      [currentOrg]="currentOrg"
    ></app-post-details-content>
    <hr class="d-inline-block" />
  </div>
</div>
<div class="modal-footer message-command">
  <button type="button" class="btn btn-outline-secondary" (click)="close()">
    {{ 'Close' | translate | uppercase }}
  </button>
</div>
